<template>
  <div class="design">
    <common-carousel :carouselData="carouselData" />

    <div class="design-main">
      <div
        class="main-item"
        :class="[{ 'default-theme': item.key % 2 == 1 }, 'kkkkk']"
        v-for="item in mainList"
        :key="item.key"
      >
        <div class="item flex-display">
          <template v-if="item.key % 2 == 1">
            <div class="img-frame">
              <img :src="item.img" alt="" />
            </div>
            <div class="text-frame flex-display flex-center-align">
              <div class="text-content flex-display flex-display-column">
                <span class="title">{{ item.title }}</span>
                <span class="sub-title">{{ item.subTitle }}</span>
              </div>
            </div>
          </template>

          <template v-if="item.key % 2 == 0">
            <div class="text-frame flex-display flex-center-align">
              <div class="text-content flex-display flex-display-column">
                <span class="title">{{ item.title }}</span>
                <span class="sub-title">{{ item.subTitle }}</span>
              </div>
            </div>
            <div class="img-frame"><img :src="item.img" alt="" /></div>
          </template>
        </div>
      </div>
    </div>

    <div
      class="design-footer"
      :style="{
        background: `#fc906a url(${$baseImgUrl}images/design-footer.png) no-repeat 100% 100%`,
        'background-size': '100% 100%',
      }"
    >
      <div class="container flex-display flex-center-pack flex-center-align">
        <div class="left">
          <span class="text">输入网址</span>
          <span class="text">浏览更多设计中台功能</span>
        </div>
        <div class="search-frame">
          <div class="input flex-display flex-center-align">
            <span class="input-text">{{ href }}</span>
          </div>
          <img
            class="icon pointer"
            @click="goKabelShop"
            :src="`${$baseImgUrl}images/icon-search-to.png`"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonCarousel from '@/components/common/carousel'

export default {
  name: 'Design',
  components: {
    commonCarousel
  },
  data () {
    return {

      carouselData: [
        {
          title: '设计中台',
          subTitle: '3D家居云设计，门店签单神器',
          icon: `${this.$baseImgUrl}images/design-slideshowIcon-1.png`,
          rightImg: `${this.$baseImgUrl}images/design-slideshowRight-1.png`,
          url: `${this.$baseImgUrl}images/design-slideshow-1.png`,
          video: `${this.$baseImgUrl}videos/4-zhongtai.mp4`
        }
      ],
      href: 'http://shop.kabel.work/',
      mainList: [{
        key: 1,
        img: `${this.$baseImgUrl}images/design-one.png`,
        title: '共享设计师',
        subTitle: '共享全国设计师，一万套设计方案随便用，小白秒变设计大咖'

      },

      {
        key: 2,

        img: `${this.$baseImgUrl}images/design-two.png`,

        title: '所想即所见',
        subTitle: '客户所想即所及所见，所见即所得'

      },
      {
        key: 3,
        img: `${this.$baseImgUrl}images/design-three.png`,

        title: '一键生成清单',
        subTitle: '方案一键生成报价清单，一键成交'

      }]
    }
  },
  methods: {
    goKabelShop () {
      window.open(this.href, '_blank') // 在新窗口打开外链接
    }
  }
}
</script>
<style lang="less" scoped>
.design {
  margin-top: 70px;
}
.design-main {
  padding-bottom: 100px;
  .main-item {
    height: 700px;
    background: #f5f8fe;
    .item {
      width: 1360px;
      margin: 0 auto;
      .img-frame {
        width: 700px;
        height: 700px;
      }
      .text-frame {
        flex: 1;
        height: 700px;
        padding-left: 100px;
        .title {
          margin-bottom: 40px;
          font-size: 40px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          line-height: 60px;
        }
        .sub-title {
          width: 380px;
          font-size: 20px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
        }
      }
    }
  }
  .default-theme {
    background: #fff;
  }
}
.design-footer {
  height: 130px;
  width: 100%;

  .container {
    height: 100%;
    box-sizing: border-box;

    .left {
      margin-right: 207px;
      .text {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
      }
      .text:nth-child(1) {
        margin-right: 20px;
      }
    }
    .search-frame {
      position: relative;
      .input {
        width: 465px;
        height: 60px;
        outline: none;
        padding: 0 33px;
        border: none;
        background: #ffffff;
        box-shadow: 0px 10px 20px 0px rgba(220, 90, 24, 0.25);
        border-radius: 31px;
        .input-text {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #e2b282;
          line-height: 28px;
        }
      }
      .icon {
        position: absolute;
        width: 99px;
        height: 50px;
        right: 5px;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/design.vue